import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {NchTempSssDto} from "../../generated-model/model";

@Injectable({providedIn: "root"})
export class TempSssResource {
  http = inject(HttpClient);

  findLast(pid: string) {
    return this.http.get<NchTempSssDto>(`${environment.serverUrl}/api/temp-sss/find-last/${pid}`);
  }
}
